export const Marquee = ({ items, className = "" }) => {
  const row = [...items, ...items];
  return (
    <div className={`relative overflow-hidden border-y border-white/10 bg-ink py-6 ${className}`} data-testid="marquee">
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {row.map((it, i) => (
          <span key={i} className="mx-8 flex items-center gap-8 font-display text-2xl font-light uppercase tracking-[0.35em] text-white/40 md:text-4xl">
            {it}
            <span className="text-gold">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};
